import { Reducer } from 'redux';

import { ThreadExtendedActivityLoadAction } from '../../domains/threadExtendedActivity/actions.types';

import { ThreadExtendedActivityLifecycle } from './types';

const initialState: ThreadExtendedActivityLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<ThreadExtendedActivityLifecycle, ThreadExtendedActivityLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'THREAD_EXTENDED_ACTIVITY.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'THREAD_EXTENDED_ACTIVITY.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.threadExtendedActivity };
    case 'THREAD_EXTENDED_ACTIVITY.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
